import _asyncToGenerator from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import OAuth from 'src/oauth';
import axios from 'axios';
var http = axios.create();
var auth = new OAuth();
export default function (_x, _x2, _x3) {
  return _ref.apply(this, arguments);
}
function _ref() {
  _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(to, from, next) {
    var _yield$http$get, data, user, _t;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!to.params.token) {
            _context.next = 6;
            break;
          }
          auth.logout();
          _context.prev = 1;
          _context.next = 2;
          return http.get(env('API_URL') + '/sign-in/' + to.params.token);
        case 2:
          _yield$http$get = _context.sent;
          data = _yield$http$get.data;
          auth.storeSession(data);
          _context.next = 3;
          return auth.currentUser();
        case 3:
          user = _context.sent;
          if (user) {
            next('/');
          } else {
            next();
          }
          _context.next = 5;
          break;
        case 4:
          _context.prev = 4;
          _t = _context["catch"](1);
          // Token invalid/expired - redirect to login
          next('/login');
        case 5:
          _context.next = 7;
          break;
        case 6:
          next();
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 4]]);
  }));
  return _ref.apply(this, arguments);
}